import { ArrowBackIosNew } from "@mui/icons-material";
import { Box, IconButton, Step, StepLabel, Stepper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getAllCredentials } from "../../../redux/actions/credentialAction";
import {
  getAllProvision,
  getAllServices,
} from "../../../redux/actions/provisionAction";
import storage from "../../../utils/storage";
import ProvisionDetails from "./provisionDetails";
import ProvisionForm from "./provisionForm";
import SelectService from "./selectService";
import { useStyles } from "./styles";
import { stepLables } from "./utils";

let steps = ["Select Service", "Provision Details", "Service Details"];

const ManageProvision = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const defaultState = location.state;
  const { allProvisions } = useSelector((state) => state.provision);
  const [step, setStep] = useState(0);
  const [labels, setLabels] = useState(steps);
  const [service, setService] = useState(null);
  const [userProvision, setUserProvision] = useState([]);

  useEffect(() => {
    dispatch(getAllCredentials());
    dispatch(getAllServices());
    dispatch(getAllProvision());
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (["/provision/edit", "/provision/clone"].includes(location.pathname)) {
      setStep(1);
      setLabels(
        location.pathname === "/provision/edit"
          ? stepLables.edit
          : stepLables.clone
      );
      if (!location.state) {
        history.push("/provision");
      }
    }
    //eslint-disable-next-line
  }, [location, history]);

  useEffect(() => {
    if (location.pathname === "/provision/new") {
      checkProvisionAvailability();
    }
    //eslint-disable-next-line
  }, [location, history, allProvisions]);

  const checkProvisionAvailability = async () => {
    const currentUser = await storage.getItem("auth");
    const userEmail = currentUser?.username || currentUser?.account?.username;
    let provisionsByUser = allProvisions.filter(
      (data) => data.createdBy === userEmail
    );
    setUserProvision(provisionsByUser);
  };

  const onServiceSelect = (service) => {
    setService(service);
    setStep(1);
  };

  return (
    <Box className={classes.root}>
      <Box width="100%" display="flex" alignItems="center" mb={1}>
        <IconButton
          sx={{
            display: step === 0 ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
          }}
          color="default"
          onClick={() => history.goBack()}
        >
          <ArrowBackIosNew />
        </IconButton>
        <Box width="100%" display="flex" justifyContent="center">
          <Stepper sx={{ width: "70%" }} activeStep={step}>
            {labels.map((label) => {
              return (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </Box>
      </Box>
      <SelectService
        defaultState={defaultState}
        show={step === 0}
        onSelect={onServiceSelect}
      />
      <ProvisionDetails
        editMode={location.pathname === "/provision/edit"}
        userProvision={userProvision}
        service={service}
        defaultState={defaultState}
        show={step === 1}
        onSubmit={() => setStep(2)}
        onBack={() => setStep(0)}
      />
      <ProvisionForm
        defaultState={defaultState}
        show={step === 2}
        onBack={() => setStep(1)}
      />
    </Box>
  );
};

export default ManageProvision;
